import { Component } from '@angular/core';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  constructor() {
    this.changeTitle();
    this.changeFaviconDynamic();
  }

  changeFaviconDynamic() {
    if(!environment.site.favicon_url.length) {
      return;
    }

    let link = document.createElement('link');
      link.type = 'image/x-icon';
      link.rel = 'shortcut icon';
      link.href = environment.site.favicon_url;
      document.getElementsByTagName('head')[0].appendChild(link);
  }

  changeTitle() {
    let title = document.querySelector('title');
    title.text = 'Личный кабинет арендатора ' + environment.site.title;
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts